import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, role }) => {
  const token = localStorage.getItem("token");

  const isPatient = !!localStorage.getItem("patientID");
  const isWorker = !!localStorage.getItem("workerID");
  const isAdmin = !!localStorage.getItem("adminID");  // ✅ ADD THIS

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (role === "patient" && !isPatient) {
    return <Navigate to="/" replace />;
  }

  if (role === "worker" && !isWorker) {
    return <Navigate to="/" replace />;
  }

  if (role === "admin" && !isAdmin) {   // ✅ ADD THIS
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
